<template>
    <div class="view view--edit-startdesk">
        <edit-startdesk v-bind:id="id" />
    </div>
</template>

<script>
    import editStartdesk from '../../components/EditStartdesk.vue';

    export default {
        components: {
            editStartdesk
        },
        data: function () {
            return {
                id: parseInt(this.$route.params.startdesk) || null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/startdesks/Edit.vue